import React from 'react';

const STYLES = {
  PENDING: 'bg-[#EFE7D8] text-kelate-darkwood',
  ACCEPTED: 'bg-[#E4E9DD] text-[#4C5A3E]',
  PREPARING: 'bg-[#E4E9DD] text-[#4C5A3E]',
  READY_FOR_PICKUP: 'bg-[#E4E9DD] text-[#4C5A3E]',
  WAITING_PICKUP: 'bg-[#EFE7D8] text-kelate-darkwood',
  WAITING: 'bg-[#EFE7D8] text-kelate-darkwood',
  ASSIGNED: 'bg-[#E4E9DD] text-[#4C5A3E]',
  PICKED_UP: 'bg-[#E4E9DD] text-[#4C5A3E]',
  OUT_FOR_DELIVERY: 'bg-[#E3E0EA] text-[#4E4866]',
  ARRIVED: 'bg-[#E3E0EA] text-[#4E4866]',
  DELIVERED: 'bg-[#DCE5D8] text-[#3E5232]',
  COMPLETED: 'bg-[#DCE5D8] text-[#3E5232]',
  CANCELLED: 'bg-[#F0E0D8] text-kelate-red',
  FAILED: 'bg-[#F0E0D8] text-kelate-red',
  DUE_ON_DELIVERY: 'bg-[#EFE7D8] text-kelate-darkwood',
  COLLECTED_BY_DRIVER: 'bg-[#E3E0EA] text-[#4E4866]',
  COLLECTED: 'bg-[#E3E0EA] text-[#4E4866]',
  VERIFICATION_REQUIRED: 'bg-[#F0E0D8] text-kelate-red',
  CONFIRMED: 'bg-[#DCE5D8] text-[#3E5232]',
  REFUNDED: 'bg-[#F0E0D8] text-kelate-red',
  AWAITING_HANDOVER: 'bg-[#EFE7D8] text-kelate-darkwood',
  HANDED_TO_FINANCE: 'bg-[#E3E0EA] text-[#4E4866]',
  RECONCILED: 'bg-[#DCE5D8] text-[#3E5232]',
  DISCREPANCY: 'bg-[#F0E0D8] text-kelate-red',
  NOT_ELIGIBLE: 'bg-[#EFEAE2] text-kelate-soft',
  READY: 'bg-[#DCE5D8] text-[#3E5232]',
  PROCESSING: 'bg-[#E3E0EA] text-[#4E4866]',
  PAID: 'bg-[#DCE5D8] text-[#3E5232]',
  ON_HOLD: 'bg-[#EFE7D8] text-kelate-darkwood',
  CHANGES_REQUESTED: 'bg-[#EFE7D8] text-kelate-darkwood',
  APPROVED: 'bg-[#DCE5D8] text-[#3E5232]',
  REJECTED: 'bg-[#F0E0D8] text-kelate-red',
};

const LABELS = {
  PENDING: 'New', ACCEPTED: 'Accepted', PREPARING: 'Preparing', READY_FOR_PICKUP: 'Ready for Pickup',
  WAITING_PICKUP: 'Waiting Pickup', WAITING: 'Waiting', ASSIGNED: 'Assigned', PICKED_UP: 'Picked Up',
  OUT_FOR_DELIVERY: 'Out for Delivery', ARRIVED: 'Arrived', DELIVERED: 'Delivered', COMPLETED: 'Completed',
  CANCELLED: 'Cancelled', FAILED: 'Failed', DUE_ON_DELIVERY: 'Pay on Delivery',
  COLLECTED_BY_DRIVER: 'With Driver', COLLECTED: 'Collected', VERIFICATION_REQUIRED: 'Needs Verification',
  CONFIRMED: 'Confirmed', REFUNDED: 'Refunded', AWAITING_HANDOVER: 'Awaiting Handover',
  HANDED_TO_FINANCE: 'With Finance', RECONCILED: 'Reconciled', DISCREPANCY: 'Discrepancy',
  NOT_ELIGIBLE: 'Not Eligible', READY: 'Ready', PROCESSING: 'Processing', PAID: 'Paid',
  ON_HOLD: 'On Hold', CHANGES_REQUESTED: 'Changes Requested', APPROVED: 'Approved', REJECTED: 'Rejected',
};

export function StatusBadge({ status, testId }) {
  return (
    <span
      data-testid={testId || `status-${String(status).toLowerCase().replace(/_/g, '-')}`}
      className={`inline-flex items-center rounded-sm px-2 py-0.5 text-[11px] font-medium tracking-wide ${STYLES[status] || 'bg-secondary text-kelate-soft'}`}
    >
      {LABELS[status] || status}
    </span>
  );
}
